import script from "./Shuiyin.vue?vue&type=script&setup=true&lang=js"
export * from "./Shuiyin.vue?vue&type=script&setup=true&lang=js"

import "./Shuiyin.vue?vue&type=style&index=0&id=405ac2ee&lang=css"

const __exports__ = script;

export default __exports__